export default "__VITE_ASSET__BOa6ool6__"